// api/auth.js
import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:8000',
  headers: { 'Content-Type': 'application/json' },
});

// ─── AUTH ────────────────────────────────────────────────────────────────
export function signup(data) {
  return api.post('/api/auth/signup', data);
}

export function checkUsername(username) {
  return api.get(`/api/auth/check-username?username=${username}`);
}

export async function login(username, password) {
  const payload = new URLSearchParams();
  payload.append('username', username);
  payload.append('password', password);
  payload.append('grant_type', 'password');

  const resp = await api.post('/api/auth/login', payload, {
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  });
  const { access_token, driver_id, session_id } = resp.data;

  localStorage.setItem('token', access_token);
  localStorage.setItem('driverId', driver_id);
  localStorage.setItem('sessionId', session_id);
  return { driver_id, session_id };
}

export function logout() {
  const driverId = localStorage.getItem('driverId');
  const sessionId = localStorage.getItem('sessionId');
  
  // Call logout endpoint if we have the required data
  if (driverId && sessionId) {
    api.post('/api/auth/logout', { driver_id: driverId, session_id: sessionId });
  }
  
  // Clear all local storage
  localStorage.removeItem('token');
  localStorage.removeItem('driverId');
  localStorage.removeItem('sessionId');
  localStorage.removeItem('loads_data');
  localStorage.removeItem('topLoadsData');
  localStorage.removeItem('lowerRate');
  localStorage.removeItem('upperRate');
  localStorage.removeItem('isSearching');
  localStorage.removeItem('isNegotiating');
}

// ─── DRIVER LIFECYCLE ────────────────────────────────────────────────────
export function conversationStarted(driverId) {
  const sessionId = localStorage.getItem('sessionId');
  return api.post('/api/conversation_started', { 
    id: driverId,
    session_id: sessionId
  });
}

export function tell(driverId, key, value) {
  const sessionId = localStorage.getItem('sessionId');
  return api.post('/api/tell', { 
    id: driverId,
    session_id: sessionId,
    key,
    value
  });
}

// ─── LOAD SEARCH ─────────────────────────────────────────────────────────
export function initiateSearch(driverId) {
  const sessionId = localStorage.getItem('sessionId');
  return api.post('/api/initiate_search', { 
    id: driverId,
    session_id: sessionId
  });
}


export function getLoads(driverId) {
  const sessionId = localStorage.getItem('sessionId');
  return api.post('/api/get_loads', { 
    id: driverId,
    session_id: sessionId
  });
}

export function getTopLoads(driverId) {
  const sessionId = localStorage.getItem('sessionId');
  return api.post('/api/top_loads', { 
    id: driverId,
    session_id: sessionId
  });
}

// ─── NEGOTIATION STATUS ─────────────────────────────────────────────────
export function getNegotiationStatus(driverId) {
  const sessionId = localStorage.getItem('sessionId');
  return api.post('/api/negotiation_status', { 
    id: driverId,
    session_id: sessionId
  });
}

// ─── NEGOTIATION ACTIONS ───────────────────────────────────────────────
export function startNegotiation(driverId) {
  const sessionId = localStorage.getItem('sessionId');
  return api.post('/api/negotiation_started', {
    id: driverId,
    session_id: sessionId
  });
}

export function updateNegotiation(driverId, data) {
  const sessionId = localStorage.getItem('sessionId');
  return api.post('/api/negotiation_update', {
    id: driverId,
    session_id: sessionId,
    ...data
  });
}

export function getNegotiationRawUpdate(driverId) {
  const sessionId = localStorage.getItem('sessionId');
  return api.post('/api/negotiation_raw_update_dispatcher', {
    id: driverId,
    session_id: sessionId
  });
}

export function updateNegotiationRaw(driverId, status) {
  const sessionId = localStorage.getItem('sessionId');
  return api.post('/api/negotiation_raw_update', {
    id: driverId,
    session_id: sessionId,
    negotiation_status: status
  });
}

export function checkPrice(driverId, proposedRate) {
  const sessionId = localStorage.getItem('sessionId');
  return api.post('/api/price_check', {
    id: driverId,
    session_id: sessionId,
    proposed_rate: proposedRate
  });
}

export function updateDriverAll(driverId, data) {
  const sessionId = localStorage.getItem('sessionId');
  return api.post('/api/driver/update_all', {
    id: driverId,
    session_id: sessionId,
    ...data
  });
}




